// Constants
import ColumnName from '../column-name/column-name.constants';
import Kendo from '../../../constants/kendo.constants';

export default {
  columns: [
    {
      ...ColumnName.buttons,
      cell: Kendo.cellTemplateNames.buttons,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      columnMenu: false,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.buttons
    },
    /* This section was auto-generated by bzs-helper ($Properties$) */
    {
      ...ColumnName.OilSample.sampleNumber,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.OilSample.jobNumber,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.small
    },
    {
      ...ColumnName.OilSample.sampleSeverityName,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.small
    },
    {
      ...ColumnName.OilSample.dateReceived,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.date
    },
    {
      ...ColumnName.OilSample.dateSampled,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.date
    },
    {
      ...ColumnName.OilSample.customerName,
      cell: Kendo.cellTemplateNames.customerName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.customerCode,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.customerThirdParty,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.unitId,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      selectedLargeView: false,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.unitName,
      cell: Kendo.cellTemplateNames.unit,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.unitTypeName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.manufacturerModelName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.fluidName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidManufacturerName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidBrandName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidClass,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidWeightName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.small
    },
    {
      ...ColumnName.Fluid.fluidKeywords,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.fluidActionName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.fluidActionCode,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.makeUpOil,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.OilSample.makeUpOilUnitOfMeasureName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.meterReading,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.OilSample.meterReadingUnitOfMeasureName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.milesOrHoursOnSample,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.OilSample.milesOrHoursOnSampleUnitOfMeasureName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.comments,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.customerComments,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.aluminum,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.barium,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.boron,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.cadmium,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.calcium,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.chromium,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.copper,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.iron,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.lead,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.magnesium,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.manganese,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.molybdenum,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.nickel,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.phosphorous,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.potassium,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.titanium,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.vanadium,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.silicon,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.silver,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.sodium,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.tin,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.zinc,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.waterPercent,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 2,
      roundOnSave: true
    },
    {
      ...ColumnName.OilSample.waterPpm,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      roundDecimals: true,
      decimalPlaces: 0,
      roundOnSave: true,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.OilSample.oxidation,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.nitration,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.sulfation,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.newOxidation,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.newNitration,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.newSulfation,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.sootIndex,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 2
    },
    {
      ...ColumnName.OilSample.viscosity100c,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: false,
      decimalPlaces: 1
    },
    {
      ...ColumnName.OilSample.viscosity40c,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: false,
      decimalPlaces: 1
    },
    {
      ...ColumnName.OilSample.fuelDilution,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: false,
      decimalPlaces: 1
    },
    {
      ...ColumnName.OilSample.antifreeze,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal
    },
    {
      ...ColumnName.OilSample.tan,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: false,
      decimalPlaces: 2
    },
    {
      ...ColumnName.OilSample.tbn,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: false,
      decimalPlaces: 2
    },
    {
      ...ColumnName.OilSample.bn,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: false,
      decimalPlaces: 2
    },
    {
      ...ColumnName.OilSample.sulphur,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: false,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.chlorine,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: false,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.mpc,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.decimal,
      roundDecimals: false,
      decimalPlaces: 1
    },
    {
      ...ColumnName.OilSample.isoClassCode,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.particleCount4,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.particleCount6,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.particleCount10,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.particleCount14,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.particleCount25,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.particleCount50,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.particleCount100,
      cell: Kendo.cellTemplateNames.severity,
      filter: Kendo.filter.numeric,
      isFilterableByFloat: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      selectedLargeView: true,
      width: Kendo.size.width.decimal,
      roundDecimals: true,
      decimalPlaces: 0
    },
    {
      ...ColumnName.OilSample.billingThirdParty,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.OilSample.isBillable,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.OilSample.isBillingTAN,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.OilSample.isBillingTBN,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.OilSample.isBillingBN,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.OilSample.isBillingKF,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.OilSample.isBillingCL,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.OilSample.isBillingPC,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.OilSample.isBillingGLY,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.OilSample.isBillingSUL,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.OilSample.isBillingNC,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.OilSample.isBillingNOB,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.OilSample.isBillingRUSH,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.OilSample.modifiedOn,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.date
    },
    {
      ...ColumnName.OilSample.createdOn,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.date
    }
  ],
  doClientSide: false,
  filter: {
    logic: 'and',
    filters: []
  },
  paging: {
    pageSize: 10,
    skip: 0,
    take: 10
  },
  searchHeader: 'Search Oil Samples',
  searchPlaceholder: 'Enter keywords...',
  sort: [],
  title: 'Oil Samples Grid'
};
